import React, { PureComponent } from "react";
import AddIssueForm from "./AddIssueForm";
class AddIssue extends PureComponent {
  render() {
    const {
      title,
      issueSaved,
      handleProposalChange,
      showLanguageError,
      params: { isProjectAwardedByState, showModal },
      onValidateForm,
      onRemoveFileDetail,
      issueCOListData,
      backButtonPress,
      ministryList,
      STATE,
      districtList,
      subCategoryList,
      milestoneLists,
      milestoneTables,
      CENTRAL,
      DISTRICT,
      STATE_DEPARTMENT,
      CENTRAL_DEPARTMENT,
      OTHER,
      INDUSTRIAL
    } = this.props;
    return (
      <React.Fragment>
        <h2 className={"page-heading"}>{title}</h2>
        {isProjectAwardedByState ? (
          <p className={"page-subline-issue"}>
            One issue can be tagged to one only District/Department at a time.
            For tagging another District/Department, raise a new issue after
            submitting the form
          </p>
        ) : (
          <p className={"page-subline-issue"}>
            One issue can be tagged to one only Ministry/State at a time. For
            tagging another Ministry/State, raise a new issue after submitting
            the form
          </p>
        )}
        <AddIssueForm
          params={this.props.params}
          issueSaved={issueSaved}
          handleProposalChange={handleProposalChange}
          showLanguageError={showLanguageError}
          onValidateForm={onValidateForm}
          onRemoveFileDetail={onRemoveFileDetail}
          issueCOListData={issueCOListData}
          backButtonPress={backButtonPress}
          ministryList={ministryList}
          STATE={STATE}
          districtList={districtList}
          subCategoryList={subCategoryList}
          milestoneLists={milestoneLists}
          milestoneTables={milestoneTables}
          CENTRAL={CENTRAL}
          DISTRICT={DISTRICT}
          STATE_DEPARTMENT={STATE_DEPARTMENT}
          CENTRAL_DEPARTMENT={CENTRAL_DEPARTMENT}
          OTHER={OTHER}
          INDUSTRIAL={INDUSTRIAL}
        />
      </React.Fragment>
    );
  }
}

export default AddIssue;
